/// <amd-module name="Repos/Tfvc/Views/ChangeDetails/Components/ChangeFilesTab" />
import * as React from "react";
import { DiscussionFilterOptions } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { ChangesExplorerView } from "Repos/Changes/Components/ChangesExplorerView";
import { ChangesContext } from "Repos/ChangesCommon/ChangesContext";
import { IChangeCollection } from "Repos/ChangesCommon/Contracts";
import { TfvcVersionDescriptor } from "Repos/Common/Contracts/Git";
import * as Resources from "Repos/Tfvc/Views/ChangeDetails/Resources";
import { getKeywordFilterItem } from "VSSUI/Filter";
import { IListBoxItem } from "VSSUI/ListBox";
import { Observer } from "VSSUI/Observer";
import { AggregateItemProvider } from "VSSUI/Utilities/AggregateItemProvider";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";
import { useChangeDetailsContext } from "../ChangeDetailsContext";
import { FilesFilterKeys } from "../ChangeDetailsViewService";

export const ChangeDetailsFilesTab = (): JSX.Element => {
    const { discussionService, filesService, getFileUrl, navigationService, viewService } = useChangeDetailsContext();
    const filterStore = viewService.getFilesFilter();
    const [selection] = React.useState(new DropdownSelection());

    return (
        <ChangesContext.Provider value={{ filesService, navigationService, viewService }}>
            <Observer changes={viewService.getChanges()} allFiles={viewService.getAllChangedPaths()}>
                {(props: { changes: IChangeCollection<TfvcVersionDescriptor>; allFiles: string[] }) => {
                    const filterProvider = new AggregateItemProvider<IListBoxItem<{}>>();
                    const files: IListBoxItem<boolean>[] = props.allFiles.map(file => ({ id: file, text: file }));
                    filterProvider.push(files);
                    filterProvider.push(DiscussionFilterOptions);

                    return (
                        <ChangesExplorerView
                            addDiffKeyboardShortcuts={true}
                            changes={props.changes}
                            discussionService={discussionService}
                            filterProps={{
                                filterStore,
                                filterItems: [
                                    getKeywordFilterItem(filterStore, 400, files),
                                    {
                                        filterItemKey: FilesFilterKeys.discussions,
                                        id: "files-discussions-filter",
                                        items: DiscussionFilterOptions,
                                        name: Resources.FilesFilterDiscussions
                                    }
                                ],
                                items: filterProvider,
                                selection,
                                showActiveFilterResetButton: true,
                                showFilterOnText: false
                            }}
                            getFileUrl={getFileUrl}
                            getItemMenuItems={viewService.getItemMenuItems}
                            selectedThreadId={viewService.getSelectedThreadId()}    
                            isChangeset={true}                        
                        />
                    );
                }}
            </Observer>
        </ChangesContext.Provider>
    );
};
